import { ConnectionEvents } from '../globals/constant';
export class ConnectionProgressEvent {
    constructor(connectionId) {
        this.name = ConnectionEvents.ConnectionProgress;
        this.connectionId = connectionId;
    }
}
